export default function() {
  return [
    {
      title: "Dashboard",
      key: "dashboard",
      htmlBefore: '<i class="far fa-chart-bar"></i>',
      to: {
        name: "dashboard"
      }
    },
    {
      title: "Negócios",
      key: "deals",
      htmlBefore: '<i class="fas fa-business-time"></i>',
      items: [
        {
          title: "Negociações em andamento",
          to: "/deals/prospects",
          htmlBefore: '<i class="fas fa-id-badge"></i>',
          htmlAfter: ""
        },
        {
          title: "Cadastro",
          to: "/deals/merchant-preview",
          htmlBefore: '<i class="fas fa-user-plus"></i>',
          htmlAfter: ""
        },
        {
          title: "Clientes",
          to: "/deals/clients",
          htmlBefore: '<i class="fas fa-user-check"></i>',
          htmlAfter: ""
        }
      ]
    },
    {
      title: "Vendas",
      key: "sales",
      htmlBefore: '<i class="fas fa-bullhorn"></i>',
      items: [
        {
          title: "Comissões",
          to: "/sales/commissions",
          htmlBefore: '<i class="fas fa-hand-holding-usd"></i>',
          htmlAfter: ""
        },
        {
          title: "Links de venda",
          to: "/sales/links",
          htmlBefore: '<i class="fas fa-link"></i>',
          htmlAfter: ""
        }
      ]
    },
    {
      title: "Relacionamento",
      key: "relationship",
      htmlBefore: '<i class="fas fa-heart"></i>',
      items: [
        {
          title: "Desempenho dos clientes",
          to: "/relationship/merchant-metrics",
          htmlBefore: '<i class="fas fa-user-tag"></i>'
        }
      ]
    },
    {
      title: "Ferramentas",
      key: "tools",
      htmlBefore: '<i class="fas fa-tools"></i>',
      items: [
        {
          title: "Calculadora de comissões",
          to: "/tools/calculator",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-calculator"></i>',
          htmlAfter: ""
        },
        {
          title: "Central de downloads",
          to: "/tools/downloads",
          htmlBefore: '<i class="fas fa-arrow-down"></i>',
          htmlAfter: ""
        }
      ]
    },
    {
      title: "Administração",
      key: "administration",
      htmlBefore: '<i class="fas fa-list"></i>',
      items: [
        {
          title: "Dados bancários",
          to: "/administration/bank",
          htmlBefore: '<i class="fas fa-piggy-bank"></i>',
          htmlAfter: ""
        },
        {
          title: "Dados do parceiro",
          to: "/administration/partner-data",
          htmlBefore: '<i class="fas fa-address-card"></i>',
          htmlAfter: ""
        },
        {
          title: "Documentos",
          to: "/administration/partner-docs",
          htmlBefore: '<i class="fas fa-file-upload"></i>',
          htmlAfter: ""
        },
        {
          title: "Notas de serviço",
          to: "/administration/note-extracts",
          dividerEnabled: true,
          htmlBefore: '<i class="fas fa-file-invoice-dollar"></i>',
          htmlAfter: ""
        },
        {
          title: "Usuários",
          to: "/administration/users",
          htmlBefore: '<i class="fas fa-user-cog"></i>',
          htmlAfter: ""
        }
      ]
    }
  ];
}



// WEBPACK FOOTER //
// ./src/data/header-nav-items.js